import { useMemo, useState } from 'react';

const useHeader = ({ company }) => {
  const [hasCompanyLogo, setHasCompanyLogo] = useState(true);

  const getCompanyLogo = useMemo(
    () =>
      company
        ? `${process.env.REACT_APP_MEDIA_BASE_URL}/ebat/company-logo/logo_${company}.svg`
        : null,
    [company],
  );

  return {
    getCompanyLogo,
    hasCompanyLogo,
    setHasCompanyLogo,
  };
};

export default useHeader;
